import type { PlatformSupportSessionPublic } from "shared";
import { apiFetch } from "./api.service";

export const platformSupportService = {
  /** GET /api/platform/sessions/:id — read-only, secret-free session lookup. */
  async getSession(sessionId: string): Promise<PlatformSupportSessionPublic> {
    const res = await apiFetch<PlatformSupportSessionPublic>(
      `/api/platform/sessions/${encodeURIComponent(sessionId)}`
    );
    if (!res.data) throw new Error("Keine Daten in der Antwort");
    return res.data;
  },
};
